import {Component, inject, OnDestroy} from '@angular/core';
import {
    RecordsTableContainerComponent
} from "../../../core/components/records-table-container/records-table-container.component";
import {TablePageComponent} from "../pages-base/table-page.component";
import {ResourceParams, resources} from "../../../core/models/resource/resources";
import {
  GetSelectDataParams
} from "../../../core/components/records-table/record-table-items/table-selects/types/dynamic.types";
import {
  DynamicService
} from "../../../core/components/records-table/record-table-items/table-selects/services/dynamic.service";
import {
  DynamicSelectStateService
} from "../../../core/components/records-table/record-table-items/table-selects/services/dynamic-select-state.service";
import {TableContextService} from "../../../core/services/table-services/table-context.service";
import { PageInfoComponent } from "../../../core/components/page-info/page-info.component";

@Component({
  selector: 'app-notes-page',
  imports: [
    RecordsTableContainerComponent,
    PageInfoComponent
  ],
  templateUrl: './notes-page.component.html',
  styleUrl: './notes-page.component.scss',
  providers: [ TableContextService ]
})
export class NotesPageComponent extends TablePageComponent implements OnDestroy {
  private dynamicService: DynamicService = inject(DynamicService);
  private dynamicSelectStateService: DynamicSelectStateService = inject(DynamicSelectStateService);

  public readonly resourceParams: ResourceParams = resources['notes'];

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    await Promise.all([
      this.getDefaultSelectDataArticle(),
      this.getDefaultSelectDataProduct()
    ]);
  }

  public ngOnDestroy(): void {
    this.dynamicSelectStateService.resetDynamicState();
  }

  private async getDefaultSelectDataArticle(): Promise<void> {
    const getSelectDataParams: GetSelectDataParams = this.dynamicService.getDefaultSelectDataParams(false);
    const selectData = await this.dynamicService.getSelectData(getSelectDataParams);
    this.dynamicSelectStateService.setDynamicState('article', selectData);
  }

  private async getDefaultSelectDataProduct(): Promise<void> {
    const getSelectDataParams: GetSelectDataParams = this.dynamicService.getDefaultSelectDataParams(true);
    const selectData = await this.dynamicService.getSelectData(getSelectDataParams);
    this.dynamicSelectStateService.setDynamicState('productId', selectData);
  }
}
